import config from '@/Constants';
import { UnexpectedError } from '@/modules/shared/domain/errors';
import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import camelToSnake from '@/utils/camelToSnake';
import snakeToCamel from '@/utils/snakeToCamel';

import { TopicComment } from '../interfaces';

const mutationKey = config.DISCUSSION_COMMENTS_URL;

// position = Ordem de exibição — espaçada (múltiplos de 10000) para permitir
// reordenar depois sem recalcular as demais mídias.
export interface CommentMediaInput {
  content: string;
  fileName: string;
  fileSize: number;
  position: number;
}

export interface TopicCommentPostData {
  content?: string;
  discussionTopicId: string;
  media?: CommentMediaInput[];
}

export const createFeedbackComment = async (
  params: TopicCommentPostData,
): Promise<TopicComment> => {
  const { media, ...rest } = params;

  // camelToSnake é raso — não converte chaves dentro de arrays de objetos.
  // Montamos as chaves snake_case do array media manualmente.
  const requestBody: Record<string, unknown> = camelToSnake(rest as any);

  if (media?.length) {
    requestBody.media = media.map((m) => ({
      content: m.content,
      file_name: m.fileName,
      file_size: m.fileSize,
      position: m.position,
    }));
  }

  const { body, statusCode } = await AxiosHelper.post({
    url: mutationKey,
    body: requestBody,
    timeout: 5000,
  });

  if (statusCode === 201) {
    return snakeToCamel(body);
  }
  if (Array.isArray(body?.error_messages) && body.error_messages.length) {
    throw new Error(body.error_messages.join(', '));
  }
  throw new UnexpectedError();
};
